import React from "react";

export const FIELD_CLASS = "w-full bg-[#F4E9D8] border border-[#1F1F1C]/20 rounded-2xl px-4 py-3 text-[#1F1F1C] text-sm focus:border-[#C8703A] focus:ring-2 focus:ring-[#C8703A]/20 focus:outline-none transition-colors placeholder:text-[#1F1F1C]/35";

const LABEL_CLASS = "block text-xs font-semibold text-[#4A463F] uppercase tracking-[0.14em] mb-1.5";

export const FieldLabel = ({ htmlFor, children, required }) => (
  <label htmlFor={htmlFor} className={LABEL_CLASS}>
    {children} {required && "*"}
  </label>
);

export const TextField = ({ id, label, type = "text", value, onChange, required, placeholder, minLength, testId }) => (
  <div>
    <FieldLabel htmlFor={id} required={required}>{label}</FieldLabel>
    <input
      id={id} name={id} type={type} value={value} onChange={onChange} minLength={minLength}
      required={required} placeholder={placeholder} className={FIELD_CLASS}
      data-testid={testId}
    />
  </div>
);

export const TextAreaField = ({ id, label, value, onChange, required, placeholder, rows = 3, minLength, testId }) => (
  <div>
    <FieldLabel htmlFor={id} required={required}>{label}</FieldLabel>
    <textarea
      id={id} name={id} value={value} onChange={onChange} rows={rows} minLength={minLength}
      required={required} placeholder={placeholder} className={`${FIELD_CLASS} resize-none`}
      data-testid={testId}
    />
  </div>
);

export const SelectField = ({ id, label, value, onChange, required, options, placeholder, testId }) => (
  <div>
    <FieldLabel htmlFor={id} required={required}>{label}</FieldLabel>
    <select
      id={id} name={id} value={value} onChange={onChange} required={required}
      className={FIELD_CLASS}
      data-testid={testId}
    >
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  </div>
);
